<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01-3">
<p class="centerImage"><img alt="images" id="img13" src="images/img13.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">Mary Aubrey dismembering her husband’s body, assisted by her young son, in 1687. Her hanging and burning at Tyburn is depicted top left. </em><span class="fontS">Author’s collection </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08a_Fouldeeds_ch013.vue?04f2504b